module.exports = "./assets/assets/3.相关政策依据.6a2b2c47.docx";